import { FilledButton } from '../util/button';
import '../util/bpUtilStyle.css';
interface CheckInReserveDialogCardProps {
  onClick: () => void;
}
export const CheckInReserveDialogCard = ({
  onClick,
}: CheckInReserveDialogCardProps) => {
  const dialogLabel = 'ご予約ありがとうございます';
  const dialogText = [
    'ご入庫予約を承りました。',
    'ご予約日のご来場をお待ちしております。',
  ];
  return (
    <div className={'dialog-card'}>
      <div className={'message-field'}>
        <div className={'message-header'}>
          <span>{dialogLabel}</span>
        </div>
        <div className={'message-body'}>
          {dialogText.map((item, idx) => (
            <span key={idx}>{item}</span>
          ))}
        </div>
      </div>
      <FilledButton onClick={onClick} label={'予約内容を確認する'} />
    </div>
  );
};
